import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import ReactToPrint from "react-to-print";
import axios from "axios";

class   ReportCardPeriod extends Component{
 
    state = {
        check : true,
        isModal : false,
        reportCards : [],
        reportcards_ : []
    }

    async getStudents(){
        
         await axios.post("students_", {
                    id: this.props.formData
                } ).then((response) => {
               this.setState({
                reportCards : response.data
            })
            this.Reportcards(response.data[0]?.sectionclass?.id)
        })
    }

    async Reportcards(val){
        var reportcards = await axios.get('reportcards/sectionclass/' + val);
        if(reportcards.status === 200)
        {
            this.setState({ reportcards_ : reportcards.data }) 
        }
    }

    edit=()=>  {
        this.getStudents()
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }
    
    checkbox = () => {
        this.setState({
            check: !this.state.check
        }); 
    }
    
    render(){
        var today = new Date();
         
        var profile = JSON.parse(localStorage.getItem('profile'))
        
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title className="font-monospace">Resultat par période</Modal.Title>
                </Modal.Header>
                    <Modal.Body>
                        <div ref={el => (this.componentRef = el)} className="row">
                        {
                            this.state.reportCards.map((student) => {
                                let point = 0, max = 0 
                                let result = student?.reportcards?.filter(val => val.periodeId == 1 && parseFloat(val.note) >= 0)?.sort((a, b) => a.sectionclasselesson?.indice > b.sectionclasselesson?.indice ? -1 : 1)?.map((val) => {
                                    point += parseFloat(val.note || 0)
                                    max += parseFloat(val.sectionclasselesson?.max_evaluation)
                                    return(
                                        <tr>
                                            <td>{ val.sectionclasselesson?.lesson?.entitled_lesson }</td>
                                            <td><span className={ ((parseFloat(val.sectionclasselesson?.max_evaluation) / 2) > parseFloat(val.note) ) ? "text-danger" : ""}>{ val.note >= 0 ? parseFloat(val.note)?.toFixed(0) : <span className="text-white">--</span> }</span>/{val.sectionclasselesson?.max_evaluation }</td>
                                        </tr>
                                    )
                                })
                                return (
                                    <div className="col-6" ref={el => (this.componentRef = el)}>
                                        <div className=" m-1 border border-1 ps-2 p-1 rounded rounded-3">
                                            <div className="text-center">
                                                <h5 className="h5 font-monospace fw-bolder">{ profile.profile?.establishment?.name} </h5>
                                                <h6 className="h6 font-monospace fw-bolder">{ student?.sectionclass?.class?.short_entitled_class} { student?.sectionclass?.section?.entitled_section} </h6>
                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="h6 font-monospace fw-bolder">{ student.user?.last_name } { student.user?.family_name } { student.user?.first_name }</div>
                                                <div>
                                                    <div  className="fw-bolder">
                                                    { 'place : ' }
                                                    {
                                                        this.state.reportcards_.filter(data => data.periodeId == 1).sort((a, b) => ( ( (parseFloat(a.student?.studentsuccess || 0) * 100 ) / parseFloat(a.student?.studentmax || 0)) < ((parseFloat(b.student.studentsuccess || 0) * 100 ) / parseFloat(b.student.studentmax || 0)) ? 1 : -1 ) ).map((place, index) => {
                                                            if(student && place.studentId == student.id){
                                                                return(
                                                                    <span style={{  fontSize : 12 + "px" }}>{index + 1 }{ index == 0 ? "iere" : "ime" } / { this.state.reportcards_.filter(stud =>stud.periodeId == 1 && stud.student.status == 1 ||  stud.periodeId == 1 && stud.student.status == 2 ).map(item => item.studentId).filter((value, index, self) => self.indexOf(value) === index).length }élèves</span>
                                                                )
                                                            }
                                                        })
                                                    }
                                                    </div>
                                                    <div>Points : { point?.toFixed(0) } </div>
                                                    <div>Maximum : { max } </div>
                                                    <div>Pourcentage : { (( point * 100) / max)?.toFixed(2) }% </div>
                                                    <hr />
                                                </div>
                                            </div>
                                            
                                            <div className="mt-3 ">
                                                <table className="table">
                                                    <thead>
                                                        <th>Cours</th>
                                                        <th>Note </th>
                                                    </thead>
                                                    <tbody>
                                                        {  result }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {/* <input type={"checkbox"} onClick={() => this.checkbox()} id="check" /> <label htmlFor="check"> imprimer en petite taille</label> */}
                        <button onClick={this.props.showModal} className="btn btn-outline-secondary btn-sm"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                        <ReactToPrint
                            trigger={() => <button className="btn btn-sm btn-outline-primary" type="button"><FeatherIcon icon={"printer"} size="22"></FeatherIcon> <span className="d-none d-sm-inline">Imprimer</span></button>}
                            content={() =>  this.componentRef}
                        />
                    </Modal.Footer>
            </Modal>
            
        </div>
        )
    }
}
export default ReportCardPeriod;